import { capitalizeString } from '../strings/capitalizeString';

export const formatMoonIllumination = (moonIllumination: string | undefined): string => {
  if (moonIllumination) {
    return capitalizeString(moonIllumination.replace('_', ' '));
  }
  return '';
};
